<template>
  <b-card no-body>
    <b-card-body>
      <create-customer-form ref="createCustomerForm" :submitting="submitting" @submit="submit" />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CreateCustomerForm from '@/views/pages/customers/components/CreateCustomerForm.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CreateCustomerForm
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createCustomer(data)
        .then(response => {
          if (
            this.$refs.createCustomerForm &&
            this.$refs.createCustomerForm.$refs.createCustomerForm
          ) {
            this.$refs.createCustomerForm.$refs.createCustomerForm.reset();
          }
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'customers_list' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
